<template>
  <div>
    <Head :title="market.label"/>
    <b-breadcrumb align="is-left">
      <b-breadcrumb-item tag='Link' href="/markets">Markets</b-breadcrumb-item>
      <b-breadcrumb-item tag='Link' active>{{ market.label }}</b-breadcrumb-item>
    </b-breadcrumb>
    <trashed-message v-if="market.deleted_at" class="mb-6" @restore="restore">
      This market has been deleted.
    </trashed-message>
    <card-component title="Edit Market">
      <form @submit.prevent="update">

        <text-input class="mb-2" v-model="form.city" :error="form.errors.city" label="City"/>
        <state-select class="mb-2" expanded v-model="form.state" :error="form.errors.state"/>
        <text-input class="mb-2" v-model="form.postal_code" :error="form.errors.postal_code" label="Zip Code"/>

        <div class="is-flex is-justify-content-flex-end px-8 py-4">
          <b-button type="is-danger" class="mx-2" v-if="!market.deleted_at" @click="destroy">
            Delete Market
          </b-button>
          <b-button type="is-info" v-if="!market.deleted_at" native-type="submit">
            Update Market
          </b-button>
        </div>
      </form>
    </card-component>

    <card-component :title="`Verticals for: ${market.label}`">
      <div class="my-2">
        <b-autocomplete
          :data="verticalList"
          placeholder="Type a Vertical Name..."
          field="title"
          @typing="updateVerticalList"
          @select="addVertical">
          <template #default="props">
            {{ props.option.name }}
          </template>
        </b-autocomplete>
      </div>
      <b-table striped bordered :data="market.verticals">
        <b-table-column label="Vertical" v-slot="{ row }">
          {{ row.name }}
        </b-table-column>
        <b-table-column numeric v-slot="{ row }">
          <Link class="button is-small is-danger" @click="removeVertical(row)">
            Remove
          </Link>
          <Link class="button is-small is-info" :href="`/sector-targets/${row.sector_target.id}`">
            View
          </Link>
        </b-table-column>
      </b-table>
    </card-component>
  </div>
</template>

<script>
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import StateSelect from '@/Shared/StateSelect'
import axios from 'axios';
import CardComponent from "@/Shared/CardComponent";

export default {
  components: {
    CardComponent,
    StateSelect,
    LoadingButton,
    TextInput,
    TrashedMessage,
  },
  props: {
    market: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        city: this.market.city,
        state: this.market.state,
        postal_code: this.market.postal_code,
        vertical_id: this.market.vertical_id,
      }),
      verticalList: [],
    }
  },
  methods: {
    update() {
      this.form.put(`/markets/${this.market.id}`)
    },
    destroy() {
      if (confirm('Are you sure you want to delete this market?')) {
        this.$inertia.delete(`/markets/${this.market.id}`)
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this market?')) {
        this.$inertia.put(`/markets/${this.market.id}/restore`)
      }
    },
    selectedData(data) {
      // console.log(data);
    },
    async updateVerticalList(query) {
      let {data} = await axios.get('/verticals/search?search=' + query);
      this.verticalList = data.verticals;
    },
    async addVertical(vertical) {
      await axios.post(`/markets/${this.market.id}/attach-vertical/${vertical.id}`);
      this.$inertia.get(`/markets/${this.market.id}/edit`)
    },
    async removeVertical(vertical) {
      await axios.delete(`/markets/${this.market.id}/detach-vertical/${vertical.id}`);
      this.$inertia.get(`/markets/${this.market.id}/edit`)
    }
  },
}
</script>
